import Vue from 'vue'
import store from './store'
import App from './App'

import 'ress/ress.css'
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store
})



// WEBPACK FOOTER //
// ./src/main.js